import { IonContent, IonGrid, IonHeader, IonPage } from "@ionic/react";
import { useEffect } from "react";
import { useLocation } from "react-router";

import { AutoNavBar } from "@/components/navbar/default-navbar/NavBarComponent";
import { MARKETING_PAGE_SECTIONS } from "@/utils/constants/menu";

import { Footer } from "../../components/footer/Footer";

import { EverythingYouNeed } from "./components/EveryYouNeed";
import { IntroSection } from "./components/Intro";
import { PremiumFeatures } from "./components/PremiumFeatures";
import { Pricing } from "./components/Pricing";
import { Testimonies } from "./components/Testimonies";
import { WhyMyFirePlane } from "./components/WhyMFP";

function MarketingPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      // Need some delay for rendering the page. It is a known Ionic issue!
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 200); // eslint-disable-line no-magic-numbers
    }
  }, [location]);

  return (
    <IonPage id="main-content" className="marketing">
      <IonHeader className="marketing-header">
        <AutoNavBar />
      </IonHeader>
      <IonContent fullscreen className="marketing-body">
        <IonGrid className="ion-no-padding marketing">
          <IntroSection id={MARKETING_PAGE_SECTIONS.IntroSection} />
          <EverythingYouNeed id={MARKETING_PAGE_SECTIONS.EverythingYouNeed} />
          <WhyMyFirePlane id={MARKETING_PAGE_SECTIONS.WhyMyFirePlane} />
          <Pricing id={MARKETING_PAGE_SECTIONS.Pricing} />
          <Testimonies id={MARKETING_PAGE_SECTIONS.Testimonies} />
          <PremiumFeatures id={MARKETING_PAGE_SECTIONS.PremiumFeatures} />
        </IonGrid>
        <Footer />
      </IonContent>
    </IonPage>
  );
}

export { MarketingPage };
